import { useState, useEffect } from "react";
import { useSearchParams } from 'react-router-dom';
import { useSelector } from "react-redux";
import ContainerRecommendationsDashboard from "../components/containers/ContainerRecommendationsDashboard";
import KimaruLoader from "../components/common/KimaruLoader";
import { showSuccessToast } from '../utils/toastUtils';
import Topbar from "../components/Topbar";

interface ContainerRecommendationPageProps {
  [key: string]: any;
}

function ContainerRecommendationPage(_props: ContainerRecommendationPageProps) {
  const userEmail = useSelector((state: any) => state.auth?.user?.email) || "monica@kimaru.ai";
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<any>(null);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const fetchRecommendations = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          "https://api.stag.kimaru.ai/api/v1/movement_recommendation/get_recommendation",
          {
            method: "GET",
            headers: {
              accept: "application/json",
              "user-email": userEmail
            },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        setData(result);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchRecommendations();
  }, [userEmail]);

  useEffect(() => {
    const actionType = searchParams.get('type');
    const location = searchParams.get('location');
    const containerId = searchParams.get('container_id');

    if (searchParams.get('actions') === 'success') {
      let successMessage = "Recommendations processed successfully!";

      if (actionType === 'sap') {
        successMessage = `Successfully updated S/4 Hana (SAP) for product recommendations located in ${location} — Container #${containerId}`;
      } else if (actionType === 'csv') {
        successMessage = `Product recommendations in ${location} — Container #${containerId}, have been successfully exported to CSV`;
      }

      showSuccessToast(successMessage, 'bottom-right');

      // Clear the success parameter from URL
      searchParams.delete('actions');
      setSearchParams(searchParams);
    }
  }, [searchParams, setSearchParams]);

  if (loading) {
    return (
      <div className="h-screen bg-slate-50 flex flex-col">
        <div className="flex-1 flex items-center justify-center">
          <KimaruLoader />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="h-screen bg-slate-50 flex flex-col">
        <div className="flex-1 flex items-center justify-center px-6">
          <div className="text-center">
            <div className="text-red-600 text-lg">
              Error loading recommendations: {error}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="h-screen bg-slate-50 flex flex-col overflow-hidden">
      <Topbar showPlaceholder={false} />
      <div className="flex-1 flex flex-col px-4 sm:px-6 pb-4 sm:pb-6 lg:pb-8 min-h-0">
        <div className="flex-1 min-h-0">
          <ContainerRecommendationsDashboard
            data={data}
          />
        </div>
      </div>
    </div>
  );
}

export default ContainerRecommendationPage;
